module.exports = __webpack_public_path__ + "img/21.f10baf30.png";